import styled from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';

import { device } from '@/styles/helpers';

const bannerBg = getCDNImageUrl('/bonuses/cp-banner-bg.webp');

export const ScCompointsBanner = styled.div<{ isWithButton: boolean }>`
  display: flex;
  padding: 16px 48px 16px 16px;
  width: 100%;
  align-items: center;
  gap: 24px;
  background-color: ${({ theme }) => theme.grayColor};
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-columns: ${({ isWithButton }) =>
    isWithButton ? '1fr 240px' : '1fr'};
  background-image: url(${bannerBg});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;

  .info-btn {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
    z-index: 2;

    & > .title {
      color: ${({ theme }) => theme.secondaryColor};

      font-size: 22px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0.44px;
      text-transform: uppercase;

      display: flex;
      gap: 12px;

      .balance {
        color: ${({ theme }) => theme.whiteColor};
      }
    }

    & > .description {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }

  & > .banner-char {
    width: 160px;
    height: 160px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (${device.mobile}) {
    display: flex;
    flex-direction: column;
    background-position: center;
    align-items: normal;
    padding: 16px;
    gap: 16px;
    background-position: left center;

    & > .banner-char {
      right: 0;
      left: auto;
      bottom: 0;
      transform: translate(0);
    }

    & > .header {
      gap: 16px;

      & > .title {
        flex-direction: column;
        padding-right: 32px;
        gap: 8px;
        font-size: 20px;
        line-height: 26px;
        letter-spacing: 0.4px;
        max-width: 90%;
      }
    }
  }
`;
